import { sportableColors } from '../../../utils/colors'
import { pitchSetupTypes } from '../../pitches/data_types'
import { defaultDoublePitch, defaultSinglePitch } from './pitch'

export const americanFootballProps = {
  reportMetricConfig: {
    playerPerformanceTable: {
      all: {
        metrics: {
          keys: ['involvements', 'involvementsPerMinute']
        },
        eventMetricGroup: {
          eventTypes: ['pass', 'kick', 'snapFlightEvent'],
          groupName: {
            en: 'Success %',
            fr: 'Succès %'
          }
        }
      }
    },
    playerComparisonTable: {
      pass: {
        metrics: [
          ['averageThrowDistance', 'averageSpeed'],
          ['averageSpin', 'averageEfficiency'],
          ['totalPasses', 'totalPassCompletion']
        ]
      }
    },
    monitoringCards: {
      technicalMetrics: [
        'involvements',
        'involvementsPerMinute',
        'totalPassCompletion',
        'averageThrowDistance',
        'averageSpeed',
        'averageSpin',
        'averageEfficiency'
      ],
      physicalMetrics: [
        'distance',
        'distancePerMin',
        'highSpeedRunningDistance',
        'highSpeedRunningDistancePerMin',
        'accelCount',
        'decelCount',
        'totalWork'
      ]
    },
    dashboardMetrics: {
      performanceAgainstAverage: [
        'involvements',
        'involvementsPerMinute',

        'distance',
        'distancePerMin',
        'highSpeedRunningDistance',
        'highSpeedRunningDistancePerMin',
        'accelCount',
        'decelCount',
        'totalWork',

        'totalPassCompletion',
        'averageThrowDistance',
        'averageSpeed',
        'averageSpin',
        'averageEfficiency'
      ],
      cardGrid: [
        ['totalPassCompletion', 'averageThrowDistance', 'averageSpeed'],
        [
          'averageSpin',
          'averageEfficiency',
          'totalPassCompletion',
          'totalPassCompletion'
        ]
      ]
    }
  },
  pitch: {
    default: defaultSinglePitch,
    defaultDoublePitch: defaultDoublePitch,
    pitchPointCount: 30,
    setupTypes: pitchSetupTypes,
    minPadding2D: 70,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 11,
    tenYardMarkings: 10,
    enableBench: true,
    enableRotate: true,
    defaultDrillRegion: {
      P1: 'P26',
      P2: 'P14',
      P3: 'P13',
      P4: 'P1',
      P5: null,
      P6: null,
      P7: null,
      P8: null
    } as const,
    drillsGoalsOrPosts: {
      enabled: false,
      dimensions: {
        large: {
          width: 7.32,
          height: 2.44,
          depth: 2.44
        },
        small: {
          width: 1.914,
          height: 1.914,
          depth: 1.61
        }
      }
    },
    drillSnapLines: [
      'P1',
      'P2',
      'P3',
      'P4',
      'P5',
      'P6',
      'P7',
      'P8',
      'P9',
      'P10',
      'P11',
      'P12',
      'P13'
    ],
    autosetupTagPositions: ['P7', 'P13', 'P15'],
    pitchCornerKeys: {
      topLeft: 'P26',
      topRight: 'P14',
      bottomRight: 'P13',
      bottomLeft: 'P1'
    },
    leftAutosetupRegion: {
      topLeft: 'P26',
      topRight: 'P20',
      bottomRight: 'P7',
      bottomLeft: 'P1'
    },
    rightAutosetupRegion: {
      topLeft: 'P20',
      topRight: 'P14',
      bottomRight: 'P13',
      bottomLeft: 'P7'
    },
    leftTeamRegion: {
      topLeft: 'P26',
      topRight: 'P25',
      bottomRight: 'P2',
      bottomLeft: 'P1'
    },
    rightTeamRegion: {
      topLeft: 'P15',
      topRight: 'P14',
      bottomRight: 'P13',
      bottomLeft: 'P12'
    }
  },
  features: {
    drillsEnabled: true,
    playerBreakdownDistanceBands: true,
    targetEvents: ['pass'],
    positionNumbers: false,
    maxPlayers: 46,
    defaultUnitSystem: 'American',
    recentEventTableMetrics: [
      'inPitchDistance',
      'inPitchHangTime',
      'speed',
      'territorialGain'
    ],
    geniusAvailable: false,
    noOfPlayersInStartingLineUp: null,
    scoreboard: false,
    homeSideCheck: false,
    bibs: {
      '1': {
        name: 'No Bib',
        colour: null
      },
      '2': {
        name: 'Offense',
        colour: sportableColors.colors.sportableRed
      },
      '3': {
        name: 'Defense',
        colour: sportableColors.colors.sportableBlue
      }
    },
    defaultBibTeamDirection: [2, 3] as number[]
  } as const
}

export const americanFootballConfig = {
  key: 'americanFootball' as const,
  value: 'AmericanFootball' as const,
  name: 'American Football',
  props: americanFootballProps
}
